import { render, staticRenderFns } from "./NewAccountModalV3.vue?vue&type=template&id=1a1c4557&"
import script from "./NewAccountModalV3.vue?vue&type=script&lang=js&"
export * from "./NewAccountModalV3.vue?vue&type=script&lang=js&"
import style0 from "./NewAccountModalV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports